export type CurrencyFormatOptions = { minimumFractionDigits?: number; maximumFractionDigits?: number };

export const currencyFormat = (
  value: number,
  currency = "USD",
  options: CurrencyFormatOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
): string => {
  const { minimumFractionDigits = 0, maximumFractionDigits = 0 } = options;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return formatter.format(value);
};

export const currencyFormatUsd = (value: number, options: CurrencyFormatOptions = {}) => {
  return currencyFormat(value, "USD", options);
};
